import { useState } from "react";
import { useFormContext, useWatch } from "react-hook-form";

// In-house components
import FormCard from "@/components/formInputFields/FormCard";
import FormSectionTitle from "@/components/formInputFields/FormSectionTitle";
import { Button } from "@/components/ui/button";
import { Plus, ChevronRight, Pencil } from "lucide-react";
import CustomerAddressModal from "./CustomerAddressModal";

export default function CustomerAddressSection() {
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);

  const { control } = useFormContext();
  const defaultAddress = useWatch({ control, name: "defaultAddress" });

  const hasAddress = defaultAddress?.addressLine1 && defaultAddress?.country;

  return (
    <>
      <FormCard className="w-full max-w-3xl">
        <FormSectionTitle>Default address</FormSectionTitle>
        <p className="mb-4 text-[14px] text-[#333333]">
          The primary address of this customer
        </p>

        {hasAddress ? (
          <div className="relative w-full rounded-md border border-[#D4D4D4] bg-[#fafafa] p-4 text-sm text-[#333333]">
            <div className="whitespace-pre-wrap leading-relaxed">
              {[
                `${defaultAddress.firstName || ""} ${defaultAddress.lastName || ""}`,
                defaultAddress.company,
                defaultAddress.addressLine1,
                defaultAddress.addressLine2,
                defaultAddress.city,
                defaultAddress.postalCode,
                defaultAddress.country,
                defaultAddress.phone,
              ]
                .filter(Boolean)
                .join("\n")}
            </div>

            <button
              type="button"
              onClick={() => setIsAddressModalOpen(true)}
              className="absolute right-2 top-2 rounded-md p-1 transition hover:bg-gray-100"
              aria-label="Edit address"
            >
              <Pencil className="h-4 w-4 text-gray-600" />
            </button>
          </div>
        ) : (
          <Button
            type="button"
            variant="outline"
            className="w-full justify-between border border-[#D4D4D4] bg-white text-[#111]"
            onClick={() => setIsAddressModalOpen(true)}
          >
            <span className="flex items-center gap-2 text-[#333333]">
              <Plus className="h-4 w-4" />
              Add address
            </span>
            <ChevronRight className="h-4 w-4 text-[#333333]" />
          </Button>
        )}
      </FormCard>

      {isAddressModalOpen && (
        <CustomerAddressModal onClose={() => setIsAddressModalOpen(false)} />
      )}
    </>
  );
};